import parseUnit from "@/lib/utils/parse-unit"

export function parseLongHandCss(data) {
  return data
    .trim()
    .replace(/\s\s+/g, " ")
    .split(" ")
    .map((v) => parseUnit(v))
}
